import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
declare var document: any;

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  token: any;
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    if (
      window.location.search &&
      window.location.search.includes("target=support")
    ) {
      setTimeout(() => {
        document.getElementById("support").scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }, 500);
    }
  }
}
